import {
    compositionTypeCodeSummaryOfFindings, emptyReasonNotStarted, sectionCodeAssertion,
    sectionCodeCertaintyOfEvidence, sectionCodeColumnHeaders, sectionCodeOutcomeMeasure,
    sectionCodeResultWithComparatorAlone, sectionCodeResultWithInterventionAlone,
    sectionCodeResultWithInterventionAloneCalculated, sectionCodeResultWithInterventionVsComparator,
    sectionCodeSampleSize, sectionCodeSummaryOfFindings
} from "../../dictionaries/CodeSystemLookup";
import generateSummaryOfFindingsFromOutcomeMeasureReport from "./generateSoFFromOMR";

const addElementValuesForSummaryOfFindingsFromComparativeEvidenceSynthesisReport = (resourceJson, resourceReferenceMap,
    associatedOutcomeMeasureReportState) => {
    if (!resourceJson) {
        return null;
    }
    let addElementValues = {
        "type": compositionTypeCodeSummaryOfFindings,
        "subject": [],
        "relatesTo": [
            {
                "type": {
                    "coding": [
                        {
                            "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
                            "code": "part-of",
                            "display": "Part Of"
                        }
                    ]
                },
                "targetReference": {
                    "reference": "Composition/" + resourceJson.id,
                    "type": "Composition",
                    "display": resourceJson.title
                }
            }
        ],
        "section": [
            {
                "title": "Column Headers",
                "code": sectionCodeColumnHeaders,
                "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">No need for narrative text.</div>"
                },
                "section": [
                    {
                        "title": "Outcome Measure",
                        "code": sectionCodeOutcomeMeasure,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Outcome</p></div>"
                        }
                    },
                    {
                        "title": "Sample Size",
                        "code": sectionCodeSampleSize,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Sample Size</p></div>"
                        }
                    },
                    {
                        "title": "Result Without Treatment",
                        "code": sectionCodeResultWithComparatorAlone,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result Without Treatment</p></div>"
                        }
                    },
                    {
                        "title": "Result With Treatment--Observed",
                        "code": sectionCodeResultWithInterventionAlone,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result With Treatment (Observed)</p></div>"
                        }
                    },
                    {
                        "title": "Result With Treatment--Derived",
                        "code": sectionCodeResultWithInterventionAloneCalculated,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result With Treatment (Calculated)</p></div>"
                        }
                    },
                    {
                        "title": "Effect Estimate",
                        "code": sectionCodeResultWithInterventionVsComparator,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Effect Estimate</p></div>"
                        }
                    },
                    {
                        "title": "Certainty of Evidence",
                        "code": sectionCodeCertaintyOfEvidence,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Certainty of Evidence</p></div>"
                        }
                    },
                    {
                        "title": "Assertion",
                        "code": sectionCodeAssertion,
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>What this means</p></div>"
                        }
                    }
                ]
            },
            {
                "title": "Summary of Findings",
                "code": sectionCodeSummaryOfFindings,
                "text": {
                    "status": "empty",
                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                },
                "section": [],
                "emptyReason": emptyReasonNotStarted
            }
        ]
    };
    if (Array.isArray(resourceJson.classification) && resourceJson.classification.length > 0) {
        let picoClassifiers = [];
        for (const item of resourceJson.classification) {
            const code = item?.type?.coding?.[0]?.code;
            if (code === "population" && item.classifier) {
                picoClassifiers.push(item);
            }
            else if (code === "intervention" && item.classifier) {
                picoClassifiers.push(item);
            }
            else if (code === "comparator" && item.classifier) {
                picoClassifiers.push(item);
            }
            else if (code === "outcome-measure" && item.classifier) {
                picoClassifiers.push(item);
            }
        }
        if (picoClassifiers.length > 0) {
            addElementValues.classification = picoClassifiers;
        }
    }
    if (resourceReferenceMap?.combinedDictionary &&
        associatedOutcomeMeasureReportState.json &&
        associatedOutcomeMeasureReportState.resourceDictionary) {
        let sofJson = generateSummaryOfFindingsFromOutcomeMeasureReport(associatedOutcomeMeasureReportState.json,
            resourceReferenceMap.combinedDictionary,
            associatedOutcomeMeasureReportState.resourceDictionary);
        addElementValues.relatesTo = sofJson.relatesTo;
        addElementValues.relatesTo.push({
            "type": {
                "coding": [
                    {
                        "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
                        "code": "part-of",
                        "display": "Part Of"
                    }
                ]
            },
            "targetReference": {
                "reference": "Composition/" + resourceJson.id,
                "type": "Composition",
                "display": resourceJson.title
            }
        });
        addElementValues.section = sofJson.section;
        addElementValues.subject = sofJson.subject;
        if (addElementValues.subject.length === 0) {
            delete addElementValues.subject;
        }
    } else {
        let populationReference;
        let interventionDescriptionReference;
        let comparatorDescriptionReference;
        let outcomeMeasuresReferences = [];
        let outcomeMeasuresListReferences = [];
        if (Array.isArray(resourceJson.section)) {
            for (const section of resourceJson.section) {
                let sectionCode = section?.code?.coding?.[0]?.code || section?.code?.text;
                if (sectionCode === "population" && section.entry?.[0]) {
                    populationReference = section.entry[0];
                }
                if (sectionCode === "intervention-description" && section.entry?.[0]) {
                    interventionDescriptionReference = section.entry[0];
                }
                if (sectionCode === "comparator-description" && section.entry?.[0]) {
                    comparatorDescriptionReference = section.entry[0];
                }
                if (sectionCode === "variables" && section.entry?.length > 0) {
                    for (const entry of section.entry) {
                        if (entry.type === "EvidenceVariable") {
                            outcomeMeasuresReferences.push(entry);
                        } else if (entry.type === "List") {
                            outcomeMeasuresListReferences.push(entry);
                        }
                    }
                }
            }
        }
        let groupAssignmentReference;
        if (interventionDescriptionReference && comparatorDescriptionReference) {
            addElementValues.contained = [{
                "resourceType": "EvidenceVariable",
                "id": "group-assignment",
                "meta": { "profile": ["http://hl7.org/fhir/uv/ebm/StructureDefinition/group-assignment"] },
                "title": "GroupAssignment: " + interventionDescriptionReference.display + " vs. " + comparatorDescriptionReference.display,
                "status": "active",
                "definition": {
                    "concept": {
                        "coding": [{
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "defined-in-handling-and-category",
                            "display": "Defined in handling and category elements"
                        }]
                    }
                },
                "handling": "dichotomous",
                "category": [
                    {
                        "name": interventionDescriptionReference.display,
                        "valueReference": interventionDescriptionReference
                    },
                    {
                        "name": comparatorDescriptionReference.display,
                        "valueReference": comparatorDescriptionReference
                    }
                ]
            }];
            groupAssignmentReference = {
                "reference": "#group-assignment",
                "type": "EvidenceVariable",
                "display": "GroupAssignment: " + interventionDescriptionReference.display + " vs. " + comparatorDescriptionReference.display
            }
        }
        let groupListSection = {
            "title": "Outcome Group List",
            "code": { "text": "OutcomeGroupList" },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        }
        if (populationReference) {
            groupListSection.entry.push(populationReference);
            addElementValues.subject.push(populationReference);
        } else {
            delete addElementValues.subject;
        }
        if (interventionDescriptionReference) {
            groupListSection.entry.push(interventionDescriptionReference);
        }
        if (comparatorDescriptionReference) {
            groupListSection.entry.push(comparatorDescriptionReference);
        }
        if (groupAssignmentReference) {
            groupListSection.entry.push(groupAssignmentReference);
        }
        if (groupListSection.entry.length > 0) {
            delete groupListSection.emptyReason;
        }
        addElementValues.section.push(groupListSection);
        if (outcomeMeasuresReferences.length > 0) {
            for (const outcomeMeasure of outcomeMeasuresReferences) {
                if (outcomeMeasure.type === "EvidenceVariable") {
                    let resultsEntry = {
                        "title": outcomeMeasure.display,
                        "code": {
                            "coding": [{
                                "system": "https://fevir.net/resources/CodeSystem/179423",
                                "code": "summary-of-findings-entry-for-a-single-outcome",
                                "display": "Summary of findings entry for a single outcome"
                            }]
                        },
                        "focus": outcomeMeasure,
                        "text": {
                            "status": "empty",
                            "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                        },
                        "section": [
                            {
                                "title": "Outcome Measure",
                                "code": sectionCodeOutcomeMeasure,
                                "text": {
                                    "status": "generated",
                                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + outcomeMeasure.display + "</p></div>"
                                },
                                "entry": [outcomeMeasure]
                            },
                            {
                                "title": "Sample Size",
                                "code": sectionCodeSampleSize,
                                "text": {
                                    "status": "empty",
                                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                                },
                                "entry": [],
                                "emptyReason": emptyReasonNotStarted
                            },
                            {
                                "title": "Result Without Treatment",
                                "code": sectionCodeResultWithComparatorAlone,
                                "text": {
                                    "status": "empty",
                                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                                },
                                "entry": [],
                                "emptyReason": emptyReasonNotStarted
                            },
                            {
                                "title": "Result With Treatment--Observed",
                                "code": sectionCodeResultWithInterventionAlone,
                                "text": {
                                    "status": "empty",
                                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                                },
                                "entry": [],
                                "emptyReason": emptyReasonNotStarted
                            },
                            {
                                "title": "Result With Treatment--Derived",
                                "code": sectionCodeResultWithInterventionAloneCalculated,
                                "text": {
                                    "status": "empty",
                                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                                },
                                "entry": [],
                                "emptyReason": emptyReasonNotStarted
                            },
                            {
                                "title": "Effect Estimate",
                                "code": sectionCodeResultWithInterventionVsComparator,
                                "text": {
                                    "status": "empty",
                                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                                },
                                "entry": [],
                                "emptyReason": emptyReasonNotStarted
                            },
                            {
                                "title": "Certainty of Evidence",
                                "code": sectionCodeCertaintyOfEvidence,
                                "text": {
                                    "status": "empty",
                                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                                },
                                "entry": [],
                                "emptyReason": emptyReasonNotStarted
                            },
                            {
                                "title": "Assertion",
                                "code": sectionCodeAssertion,
                                "text": {
                                    "status": "empty",
                                    "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                                },
                                "entry": [],
                                "emptyReason": emptyReasonNotStarted
                            }
                        ]
                    };
                    addElementValues.section[1].section.push(resultsEntry);
                }
            }
        }
    }

    return addElementValues;
};

export default addElementValuesForSummaryOfFindingsFromComparativeEvidenceSynthesisReport;